export default "__VITE_ASSET__Cy8ET5Oy__"